import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  title: 'Start rapid',
  description: 'Parcurgeți acest ghid pentru a ajunge la lansare cât mai repede',
  steps: {
    [ONBOARDING_GUIDE_STEPS.Notifications]: 'Preferințe notificări',
    [ONBOARDING_GUIDE_STEPS.OpenTimesAndLocation]: 'Program și locație',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Identitatea restaurantului',
    [ONBOARDING_GUIDE_STEPS.OrderSettings]: 'Setări comenzi',
    [ONBOARDING_GUIDE_STEPS.Menu]: 'Configurare meniu',
    [ONBOARDING_GUIDE_STEPS.Marketing]: 'Marketing & Loialitate',
    [ONBOARDING_GUIDE_STEPS.MyStore]: 'Magazinul meu',
    [ONBOARDING_GUIDE_STEPS.GoLive]: 'Lansare',
    [ONBOARDING_GUIDE_STEPS.Complete]: 'Finalizat',
  },
  toasts: {
    failed_to_load_onboarding: 'Încărcarea pașilor de onboarding a eșuat',
  },
};
